import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { navItems } from "../_nav";

@Injectable({
  providedIn: "root",
})
export class StateService {
  activeNav$: BehaviorSubject<any> = new BehaviorSubject<any>({});
  navItems$: BehaviorSubject<any[]> = new BehaviorSubject<any>(navItems);
  constructor() {}
}
